// misc imports
import 'lazysizes';
import PubSub from 'pubsub-js';
import "./modules/cards";
import "./modules/carousels";
import './modules/formHelper';
import "./modules/resizeDone";
import "./modules/responsiveBackgroundImages";
import './modules/salInit';
import "./modules/scrollPosition";
import "./modules/svgIconSprite";
import './modules/tabs';

// Rellax parallax
import Rellax from 'rellax';
let relaxxed = document.querySelectorAll('.rellax');
if ( typeof window.orientation !== "undefined" || navigator.userAgent.indexOf('IEMobile') !== -1) {
    // do nothing
} else if (relaxxed.length > 0) {
    for (let i=0; i<relaxxed.length; i++) {
        relaxxed[i].classList.add('rellax-enabled');
    }
    // prevent jankiness on mobile devices
    let rellaxed = new Rellax('.rellax');
}

// Lazy loading of scripts
import LazyScripts from 'lazy-scripts';
new LazyScripts();

// Freeform validation
import Forms from './modules/forms';

// Known forms
Forms.init('#js-contact-form');
Forms.init('#js-enquiry-form');
Forms.init('#js-service-form');
Forms.init('#js-personal-form');
Forms.init('#js-subscribe-form');

// Forms added via CMS
const freeforms = document.querySelectorAll('.js-freeform');
Array.prototype.forEach.call(freeforms, freeform => {
    let formId = freeform.querySelector('form[data-id]').getAttribute('data-id');
    if (formId) {
        //console.log(formId);
        freeform.setAttribute('data-form-id', formId);
        Forms.init('[data-form-id="'+formId+'"]');
    }
});

// Toggle regions
import Toggle from './modules/toggle';
new Toggle('#js-menu-btn');
new Toggle('#js-enquiry-btn');
new Toggle('#js-info-btn', false, false);
//Toggle.init('.js-drop-btn');
new Toggle('.js-toggle', true);
//new Toggle('#js-subnav-btn', true);
new Toggle('#js-service-form-btn');
new Toggle('#js-downloads-btn', true);

// Mmenulight
import MmenuLight from 'mmenu-light';
const menu = new MmenuLight(
    document.querySelector( "#js-menu-panel" )
);
menu.navigation({
    title : ''
});

// Drop menus
import Drop from './modules/drop';
Drop.init('[data-drop]', 'mouseleave', 500);
Drop.init('#js-drop-individuals');
Drop.init('#js-drop-businesses');
Drop.init('#js-drop-sectors');
Drop.init('#js-drop-people');


/**
 * Accept hot reloading from dev server
 * Without this you may see this warning in your console:
 * "[HMR] Cannot apply update. Need to do a full reload!"
 */
if (module.hot) module.hot.accept();